export function FormatPhone(phone) {
    if (typeof phone !== "string") {
        phone = phone.toString();
    }
    var phoneTrim = phone.trim();
    if (phoneTrim.length === 7) {
        return phoneTrim.slice(0, 3) + " " + phoneTrim.slice(3, 7);
    }
    if (phoneTrim.length === 10) {
        return (
            "(" +
            phoneTrim.slice(0, 3) +
            ") " +
            phoneTrim.slice(3, 6) +
            "-" +
            phoneTrim.slice(6, 10)
        );
    }
    return phone;
}

export function FormatWebsite(url) {
    if (!url) {
        return "";
    }
    url = url.trim();
    url = url.toLowerCase();
    if (url.startsWith("http://")) {
        url = url.substring(7);
    } else if (url.startsWith("https://")) {
        url = url.substring(8);
    }

    if (url.startsWith("www.")) {
        url = url.substring(4);
    }
    if (url.endsWith("/")) {
        url = url.substring(0, url.length - 1);
    }
    return url;
}

export function FormatEmail(email) {
    if (!email) {
        return "";
    }
    var emailTrim = email.trim();
    return emailTrim.toLowerCase();
}

export function FormatKennitala(kennitala) {
    if (!kennitala) {
        return "";
    }
    var kennitalaTrim = kennitala.trim();
    if (kennitalaTrim.length !== 10) {
        return kennitala;
    }
    return kennitalaTrim.slice(0, 6) + "-" + kennitalaTrim.slice(6, 10);
}

export function FormatAddress(street, house_number, zip, city) {
    let address = "";
    if (street) {
        address = street?.trim?.();
    }
    if (house_number) {
        address += " " + house_number?.trim?.();
    }
    if (street || house_number) {
        address += ", ";
    }
    if (zip) {
        address += zip;
    }
    if (city) {
        address += " " + city;
    }
    return address;
}
